module.exports = __webpack_public_path__ + "public/Icons/Language-icon.svg?d02a57a3";